import { useState, useEffect, useContext } from "react";
import { notify } from "../../utils/utils";
import { AuthFetch } from "../../services/api";
import { useModal } from '../.././hooks/useModal';
import { useSpinner } from "../useSpinner";
import { UserContext } from "../../context/provider/UserProvider";


const urlBaseMarcas = process.env.REACT_APP_TMAN_API + '/Tire/Brand'


export const useMarcas = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa
    
    const marcaDefault = {
        codEmpresa: codEmpresa,
        nomNeumaticoMarca: '',
        codNeumaticoMarca: 0
    }
    
    const [marca,setMarca] = useState(marcaDefault)
    const [marcas,setMarcas] = useState([])
    
    const listarMarcas = async () => {
        const response = await AuthFetch({
            url: urlBaseMarcas + '?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setMarcas(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const registrarEditarMarca = async () => {
        const esGuardar = marca.codNeumaticoMarca === 0
        const {codNeumaticoMarca,...jsonGuardar} = marca
        const response = await AuthFetch({
            url: urlBaseMarcas,
            method: esGuardar ? 'POST' : 'PUT',
            body: JSON.stringify(esGuardar ? jsonGuardar : marca)
        })

        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const eliminarMarca = async (codNeumaticoMarca) => {
        const response = await AuthFetch({
            url: urlBaseMarcas,
            method: 'DELETE',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codNeumaticoMarca: codNeumaticoMarca
            })
        })

        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }
    
    const editarValorMarca = (key,value) =>{
        setMarca(datosAnteriores => {
            return {
                ...datosAnteriores,
                [key]: value
            }
        });
    }     


    return {
        marcaDefault,
        marca,
        setMarca,
        listarMarcas,
        marcas,
        registrarEditarMarca,
        eliminarMarca,
        editarValorMarca
    }
}